import EzloActions from '../EzloActions';

/**
 * Types of hub scene broadcasts which the MeshBots list applies to the store.
 * @constant
 * @type {{CHANGE: string, REMOVE: string}}
 */
export const SCENE_BROADCAST_TYPES = {
    CHANGE: 'change',
    REMOVE: 'remove',
};

/**
 * Thunk creator that returns thunk that applies a hub.scene.changed/hub.scene.deleted
 * broadcast to the store.
 *
 * Looks up the controller owning the scene in the current store state via getState,
 * so it does not suffer from stale closures over component props and works for scenes
 * that appeared in the store after the subscription was created (ENWT-5462).
 *
 * @param {Object} broadcastData - scene data from the broadcast result, must contain _id
 * @param {string} broadcastType - one of SCENE_BROADCAST_TYPES
 * @returns {Function} returns thunk that applies the broadcast to the store
 * @example
 * dispatch(applySceneBroadcast({ _id: '666c1630...', enabled: false }, SCENE_BROADCAST_TYPES.CHANGE))
 */
export const applySceneBroadcast = (broadcastData, broadcastType) => (dispatch, getState) => {
    const ezloData = getState().ezlo?.data || {};
    const serial = Object.keys(ezloData).find((key) =>
        ezloData[key]?.rules?.some?.((rule) => rule._id === broadcastData?._id),
    );

    if (!serial) {
        return;
    }

    if (broadcastType === SCENE_BROADCAST_TYPES.CHANGE) {
        dispatch(EzloActions.updateRule(serial, broadcastData._id, broadcastData));
    }

    if (broadcastType === SCENE_BROADCAST_TYPES.REMOVE) {
        dispatch(EzloActions.removeRule(serial, broadcastData._id));
    }
};
